import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import moment from 'moment';
import Header from "../../Components/header";
import Footer from "../../Components/footer";
import "../../assets/css/style.scss";
import avtarProfile from "../../assets/images/avtar-profile.png";

import { getOrders } from '../../Services/Order'




const Userprofile = () => {
    const navigate = useNavigate();

    const [TabPanelState, setTabPanelState] = useState(1);
    const [orders, setOrders] = useState([]);
    const [orderCounts, setOrderCounts] = useState({

    });


    useEffect(() => {
        getOrdersData()
    }, [])


    let getOrdersData = async () => {
        const response = await getOrders();
        setOrders(response.data.orders)
        setOrderCounts(response.data)
    }

    const toggleTabWeb = (index) => {
        setTabPanelState(index);
    };

    let logOut = () => {
        localStorage.clear()
        navigate('/')
    }
    const getActiveClass = (index, className) =>
        TabPanelState === index ? className : "";

    return (
        <>
            <div className="wrapper">
                <Header />
                <div className="wrapper-main--elemnt py-4">
                    <div className="container-wapelemnt">
                        <div className="asside-gridbar">
                            <div className="wigit-sidemenu-elemnt">
                                <div className="full-picavatar text-center py-4">
                                    <img className="profile-avt-ueraside" src={avtarProfile} alt="" />
                                    <div className="profile-txtavtar d-none">
                                        <span class="avtar-txtcircle">H</span>
                                    </div>
                                </div>
                                <ul>
                                    <li className="navitem--menu-user">
                                        <button type="button" className={`tabmenu-user ${getActiveClass(1, "active")}`}
                                            onClick={() => toggleTabWeb(1)}
                                        ><span className="icon-menu"><i class="far fa-clipboard-list"></i></span>My Order</button>
                                    </li>
                                    <li className="navitem--menu-user">
                                        <button type="button" className={`tabmenu-user ${getActiveClass(2, "active")}`}
                                            onClick={() => toggleTabWeb(2)}
                                        ><span className="icon-menu"><i class="far fa-user"></i></span>User Profile</button>
                                    </li>
                                    <li className="navitem--menu-user">
                                        <button type="button" className={`tabmenu-user ${getActiveClass(3, "active")}`}
                                            onClick={() => toggleTabWeb(3)}
                                        ><span className="icon-menu"><i class="far fa-file-alt"></i></span>Change Password</button>
                                    </li>
                                    <li className="navitem--menu-user">
                                        <button onClick={() => logOut()} type="button" className="tabmenu-user btn-logout"><span className="icon-menu"><i class="far fa-unlock-alt"></i></span>Logout</button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="right-wap-gridcontent">
                            <div className="container-fluid">
                                <div className={`tabwap-container ${getActiveClass(1, "show")}`}>
                                    <div className="cardwap-wigit mb-4">
                                        <div className="card-body">
                                            <h3 className="mb-4 maintxt-titledash">Dashboard</h3>
                                            <div className="row rowboth-margin">
                                                <div className="col-12 col-md-6 col-lg-6 col-xl-2 boxcolumn-lyt-5">
                                                    <div className="card boxcard--wigttop bg-color-card-1">
                                                        <div className="flex--mnt--item">
                                                            <div className="iconflex--dt bg-icon-web-1">
                                                                <span><i class="far fa-shopping-cart"></i></span>
                                                            </div>
                                                            <div className="right-mv-flex">
                                                                <h5 className="heading-wp-mnt">Total Order</h5>
                                                                <span className="numb-txt-wap">{orderCounts.totalOrders}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-12 col-md-6 col-lg-6 col-xl-2 boxcolumn-lyt-5">
                                                    <div className="card boxcard--wigttop bg-color-card-2">
                                                        <div className="flex--mnt--item">
                                                            <div className="iconflex--dt bg-icon-web-2">
                                                                <span><i class="far fa-sync-alt"></i></span>
                                                            </div>
                                                            <div className="right-mv-flex">
                                                                <h5 className="heading-wp-mnt">Pending Order</h5>
                                                                <span className="numb-txt-wap">{orderCounts.pendingOrders}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-12 col-md-6 col-lg-6 col-xl-2 boxcolumn-lyt-5">
                                                    <div className="card boxcard--wigttop bg-color-card-3">
                                                        <div className="flex--mnt--item">
                                                            <div className="iconflex--dt bg-icon-web-3">
                                                                <span><i class="far fa-truck"></i></span>
                                                            </div>
                                                            <div className="right-mv-flex">
                                                                <h5 className="heading-wp-mnt">Processing Order</h5>
                                                                <span className="numb-txt-wap">{orderCounts.precessingOrders}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-12 col-md-6 col-lg-6 col-xl-2 boxcolumn-lyt-5">
                                                    <div className="card boxcard--wigttop bg-color-card-4">
                                                        <div className="flex--mnt--item">
                                                            <div className="iconflex--dt bg-icon-web-4">
                                                                <span><i class="far fa-times"></i></span>
                                                            </div>
                                                            <div className="right-mv-flex">
                                                                <h5 className="heading-wp-mnt">Canceled Order</h5>
                                                                <span className="numb-txt-wap">{orderCounts.canceledOrders}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-12 col-md-6 col-lg-6 col-xl-2 boxcolumn-lyt-5">
                                                    <div className="card boxcard--wigttop bg-color-card-5">
                                                        <div className="flex--mnt--item">
                                                            <div className="iconflex--dt bg-icon-web-4">
                                                                <span><i class="far fa-check"></i></span>
                                                            </div>
                                                            <div className="right-mv-flex">
                                                                <h5 className="heading-wp-mnt">Delivered Order</h5>
                                                                <span className="numb-txt-wap">{orderCounts.deliveredOrders}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <div className="cardwap-wigit">
                                        <div className="card-body">
                                            <h3 className="mb-4 maintxt-titledash">My Order</h3>
                                            <div className="table-responsive">
                                                <table className="table table-wapper-body">
                                                    <thead className="wp-table-head">
                                                        <tr>
                                                            <th scope="col" className="th-head-wp">Invoice</th>
                                                            <th scope="col" className="th-head-wp">Order Time</th>
                                                            <th scope="col" className="th-head-wp">Method</th>
                                                            <th scope="col" className="th-head-wp">Payment Status</th>
                                                            <th scope="col" className="th-head-wp">Order Status</th>
                                                            <th scope="col" className="th-head-wp">Total</th>
                                                            <th scope="col" className="th-head-wp">Action</th>
                                                        </tr>

                                                    </thead>
                                                    <tbody className="wp-table-body">
                                                        {
                                                            orders.map(val => {
                                                                return (
                                                                    <tr>
                                                                        <td className="td-disc-wp"><span className="txt-wps-wt">{val.invoice}</span></td>
                                                                        <td className="td-disc-wp"><span className="txt-wps-wt">{moment(val.createdAt).format('lll')}</span></td>
                                                                        <td className="td-disc-wp"><span className="txt-wps-wt">{val.paymentMethod}</span></td>
                                                                        <td className="td-disc-wp"><span className="txt-wps-wt txt-pending" style={{ fontSize: 'revert', background: val.paymentStatus == 'Paid' ? 'rgb(25 169 131)' : '#d9872c' }}>{val.paymentStatus}</span></td>
                                                                        <td className="td-disc-wp"><span style={{ fontSize: 'revert', background: val.status == 'Delivered' ? 'rgb(25 169 131)' : val.status == 'Cancel' ? 'red' : val.status == 'Pending' ? '#d9872c' : 'rgb(84 117 202)' }} className="txt-wps-wt txt-pending">{val.status}</span></td>
                                                                        <td className="td-disc-wp"><span className="txt-wps-wt">₹{val.total}</span></td>
                                                                        <td className="td-disc-wp">
                                                                            <button onClick={() => navigate(`/order/${val._id}`)} type="button" className="btn btn-detail-btn">Details</button>
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            })
                                                        }


                                                    </tbody>
                                                </table>

                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className={`tabwap-container ${getActiveClass(2, "show")}`}>
                                    <div className="user-profile-areawgt">
                                        <h3 className="maintxt-titledash mb-4">Update Profile</h3>
                                        <div className="row">
                                            <div className="col-12 col-md-6">
                                                <div className="form-group mb-3">
                                                    <label className="lbl-txtwg">Name</label>
                                                    <input type="text" value="" placeholder="Name" name="" className="form-control field-contol-nt" />
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-6">
                                                <div className="form-group mb-3">
                                                    <label className="lbl-txtwg">Email</label>
                                                    <input type="text" value="" placeholder="Email" name="" className="form-control field-contol-nt" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12 col-md-6">
                                                <div className="form-group mb-3">
                                                    <label className="lbl-txtwg">Phone No</label>
                                                    <input type="text" value="" placeholder="Phone No" name="" className="form-control field-contol-nt" />
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-6">
                                                <div className="form-group mb-3">
                                                    <label className="lbl-txtwg">Country</label>
                                                    <input type="text" value="" placeholder="Country" name="" className="form-control field-contol-nt" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12 col-md-6">
                                                <div className="form-group mb-3">
                                                    <label className="lbl-txtwg">City</label>
                                                    <input type="text" value="" placeholder="City" name="" className="form-control field-contol-nt" />
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-6">
                                                <div className="form-group mb-3">
                                                    <label className="lbl-txtwg">Address</label>
                                                    <input type="text" value="" placeholder="Address" name="" className="form-control field-contol-nt" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="form-group text-center mt-5 mb-3">
                                                    <button type="submit" className="btn btn-submit-mt">Update Profile</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className={`tabwap-container ${getActiveClass(3, "show")}`}>
                                    <div className="user-profile-areawgt">
                                        <h3 className="maintxt-titledash mb-4">Change Password</h3>
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="form-group mb-3">
                                                    <label className="lbl-txtwg">Current password</label>
                                                    <input type="email" value="" placeholder="Email" name="" className="form-control field-contol-nt" />
                                                </div>
                                                <div className="form-group mb-3">
                                                    <label className="lbl-txtwg">New password</label>
                                                    <input type="Current Password" value="" placeholder="Email" name="" className="form-control field-contol-nt" />
                                                </div>
                                                <div className="form-group mb-3">
                                                    <label className="lbl-txtwg">Confirm new password</label>
                                                    <input type="New Password" value="" placeholder="Email" name="" className="form-control field-contol-nt" />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-12">
                                                <div className="form-group text-center mt-5 mb-3">
                                                    <button type="submit" className="btn btn-submit-mt">Change Password</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        </>
    )
}
export default Userprofile